import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { sprintf } from 'sprintf-js';
import { Constants } from '../../shared/constants';
import { TranslationsService } from '../../shared/services/translations/translations.service';
import { TmsApiService } from '../../shared/services/tms-api/tms-api.service';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';
import { AnalyticsHandler } from '../../shared/libraries/analytics-handler/analytics-handler';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {
  /**
   * Entitlements returned by the confirmation action
   * @var {Array<any>}
   */
  public assignedEntitlements: Array<any>;

  /**
   * Whats next section data
   * @var {Array<any>}
   */
  public whatsNextData: Array<any>;

  /**
   * Confirmation Header object to handle title and description
   * @var {Object}
   */
  public confirmationHeader: {
    title: string,
    description: string
  };

  /**
   * Translations object
   * @var {any}
   */
  private _translations: any;


  /**
   * Class constructor
   *
   * @param _translationsService
   * @param _tmsApiService
   * @param _router
   * @param _translatePipe
   * @param _analytics
   */
  constructor(
    private _translationsService: TranslationsService,
    private _tmsApiService: TmsApiService,
    private _router: Router,
    public translatePipe: TranslatePipe,
    private _analytics: AnalyticsHandler
  ) {
    this._translations = this._translationsService.getTranslations();
  }

  /**
   * On init method
   */
  public ngOnInit() {
    this._tmsApiService.confirmedEntitlementsSubject.subscribe(
      (entitlements) => {
        this.assignedEntitlements = entitlements;
      }
    );

    if (!this.assignedEntitlements) {
      this._router.navigate(
        ['/']
      );
    }

    this.whatsNextData = this._generateWhatsNextData();
    this.confirmationHeader = this._generateConfirmationHeader(this.assignedEntitlements);

    this._analytics.getModel().then((model: any) => {
      model.pageId = 'confirmation';
      model.pageVariant = (<any>window).analyticsPageVariant;
      this._analytics.update();
    });
  }

  private _generateWhatsNextData(): Array<any> {
    let blockTitle,
      blockDescription,
      blockIcon,
      blockLink,
      index = 1;

    const whatsNextData = [];

    for (const key in this._translations) {
      if (Constants.WHATS_NEXT_REGEX.test(key)) {
        blockTitle = sprintf(Constants.WHATS_NEXT_TITLE_KEY, index);
        blockDescription = sprintf(Constants.WHATS_NEXT_DESCRIPTION_KEY, index);
        blockIcon = sprintf(Constants.WHATS_NEXT_ICON_KEY, index);
        blockLink = sprintf(Constants.WHATS_NEXT_LINK_KEY, index);

        whatsNextData.push({
          title: blockTitle,
          description: blockDescription,
          icon: blockIcon,
          link: blockLink
        });

        index++;
      }
    }

    return whatsNextData;
  }

  /**
   * @TODO Return translated confirmation header title and description
   * @param {Array<any>}
   */
  private _generateConfirmationHeader(entitlements: Array<any>): any {
    let linkActionErrors = 0;
    const totalEntitlements = entitlements.length,
    confirmationHeader = {
      title: this.translatePipe.transform('confirmation-page.success.title'),
      description: this.translatePipe.transform('confirmation-page.success.description')
    };

    for (const entitlement of entitlements) {
      if (entitlement.status !== 200) {
        ++linkActionErrors;
      }
    }

    if (!!linkActionErrors) {
      confirmationHeader.title = this.translatePipe.transform(
        'confirmation-page.partial-success.title',
        [totalEntitlements - linkActionErrors, totalEntitlements]
      );

      confirmationHeader.description = this.translatePipe.transform(
        'confirmation-page.partial-success.description'
      );
    }

    return confirmationHeader;
  }

  /**
   * Redirect user to the entry point page or homepage as default.
   */
  public redirectUserToEntryPointPage() {
    const referrerUrl = localStorage.getItem('claimReferrer');

    window.location.href = !!referrerUrl ? referrerUrl : window.location.origin;
  }

  /**
   * @desc Gets the addon names for display
   * @param {Object} supplements
   * @return {String}
   */
  public getAddOnNames(supplements) {
    const names = [];

    supplements.forEach(supplement => {
      names.push(supplement.name);
    });
    const sortedNames = names.sort().join(', ');

    return sortedNames;
  }
}
